import { isDefaultLocale } from "infrastructure/localization";

import { ITranslation, ITermDictionarySearchQuery, ITermDictionaryEntry } from "./TermDictionary.state";

const groupBy: <T extends keyof ITranslation>(translations: ITranslation[], key: T) => { [key: string]: ITranslation[] } = (translations: ITranslation[], key: string) => {
  return translations.reduce((acc, cur) => {
    (acc[cur[key]] = acc[cur[key]] || []).push(cur);
    return acc;
  }, {});
};

const createTermDictionaryEntries = (translations: ITranslation[], reversed?: boolean) => {
  const termTranslationGroups = groupBy(translations, "termId");

  const result = translations
    .filter(t => isDefaultLocale(t.locale) && t.industry === null)
    .map(t => {
      if (reversed) {
        return {
          term: termTranslationGroups[t.termId].find(g => !isDefaultLocale(g.locale) || g.industry),
          translation: { termId: t.termId, translation: t.translation, definition: t.definition, locale: t.locale }
        };
      }
      return {
        term: { termId: t.termId, translation: t.translation, definition: t.definition, locale: t.locale },
        translation: termTranslationGroups[t.termId].find(g => !isDefaultLocale(g.locale) || g.industry)
      };
    });

  return result as ITermDictionaryEntry[];
};

export const createSearchResult = (translations: ITranslation[], query: ITermDictionarySearchQuery) =>
  query.bilingual ? createTermDictionaryEntries(translations, query.localeReversed) : translations;
